$(function($) {
    "use strict";

    // serializeObject
    $.fn.serializeObject = function() {

        var o = {};
        var a = this.serializeArray();
        $.each(a,
            function() {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || "");
                } else {
                    o[this.name] = this.value || "";
                }
            });
        return o;
    };

    $('.enquiry-form').each(function() {
        var $module = $(this);
        var $form = $('form#enquiry-form');
        enquirycount();
        bindValidation($form);
        //bindAvailability($form);

        $module.find('.js-trigger-filteravailability').on('change', () => {
            if ($module.find('[name="filteravailability"]').prop('checked'))
                enquirycountdebounced();
        });
        $module.find('#childrenages-cont').hide();
        $module.find('#children').on("change",
            function() {
                var childrenCount = this.value;
                if (childrenCount > 0) {
                    $module.find('#childrenages-cont').show();
                } else {
                    $module.find('#childrenages-cont').hide();
                }

                $('#dropdown-ages').html("");

                for (var j = 0; j < childrenCount; j++) {
                    var $select = $('<select>').prop('name', 'rooms[0].childrenages').prop('id', 'childrenages').prop('class', 'js-trigger-filteravailability');

                    for (var i = 0; i <= 17; i++) {
                        var $option = $('<option>').prop('value', i).prop('text', i);
                        $select.append($option);
                    }
                    $('#dropdown-ages').append($select);
                }
            });

        $module.find(".tag-item label[name=checkbox]").each(function () {
            if ($(this).children(".tag-item input[type=checkbox]").prop("checked")) {
                $(this).toggleClass("checkedAmenity");
                $(this).parents(".amenities").prepend($(this));
                $(this).on("change",
                    function() {
                        $(this).toggleClass("checkedAmenity");
                    });
            }
        });
        $module.find(".tag-item label[name=checkbox]").on("change",
            function() {
                $(this).toggleClass("checkedAmenity");
            });

        var cars = $module.find("[name=cars]").val();
        if (cars == "") {
            cars.split("");
        }

        // -------------------- count on change ----------------------
        $module.find(".amenities input[type=checkbox]").on('change', function () { enquirycount(); });
        $module.find(".stars-enquiry input[type=checkbox]").on('change', function () { enquirycount(); });
        $module.find('[name="filter.boardingIds"]').on("click", function () { enquirycount(); });
        $module.find('[name="filteravailability"]').on("click", function (e) {
            enquirycount();
            try { if (e.target.checked) window.siteEvent('debug', 'filteravailability', ''); } catch (ignore) { }
        });
        $module.find('.region-option select[name="filter.areaIds"]').on("change", function () { enquirycount(); });
        $module.find('.theme-option select[name="filter.themeIds"]').on("change", function () { enquirycount(); });
        // ----------------------------------------------------------
        $form.find('input:visible, select:visible, textarea:visible').first().focus().change();
        function loading(isLoading) {
            $form.find('.load-spinner').toggleClass('spin', isLoading);
            $form.find(':submit').prop('disabled', isLoading);
            $module.find('.enquiryCount b').hide();
        }

        $form.on('submit',
            function(e) {
                e.preventDefault();

                var $validator = $form.validate();
                if (!$form.valid()) {
                    $form.addClass("form-error");
                    return;
                }
                $form.removeClass(".server-error .alert");
                $form.find(".server-error .alert").text("").slideUp();

                loading(true);
                var formData = $form.serializeObject();
                var data = formData;
                if (formData.roomcategoryid) data['tag'] = 'Room|' + formData.roomcategoryid;
                $.ajax({
                    cache: false,
                    url: $form.attr('action'),
                    type: $form.attr('method') || "POST",
                    data: data,
                    success: function (data) {
                        loading(false);
                        if (data != undefined && data.success === true) {
                            window.siteEventEnquiry(data, window.site.language);

                            $module.find(".enquiry-card").hide();
                            $module.find(".enquiry-title").hide();
                            $module.find(".enquiry-flyingblock-base").hide();
                            $module.find(".thankyou").fadeIn(2000);
                            $module.find(".btnGoBack").show();
                        }
                        else {
                            if (data && data.validationErrors) {
                                $validator.saveShowErrors(data.validationErrors);
                            } else {
                                $form.find(".server-error .alert")
                                    .text((data || {}).msg || $form.data("fatal-msg"))
                                    .slideDown();
                            }
                            console.log($form[0].id + " error:", data);
                        }
                    },
                    error: function(data) {
                        $form.find(".server-error .alert").text($form.data("fatal-msg")).slideDown();
                        console.log($form[0].id + " error fatal:", data);
                        loading(false);
                    }
                });

            });

        var oneCompanyCount = $(".enquiryCompanyCount span1");
        oneCompanyCount.hide();

        var enquirycountdebounce;
        function enquirycountdebounced() {
            clearTimeout(enquirycountdebounce);
            enquirycountdebounce = setTimeout(() => enquirycount(), 100);
        }

        function enquirycount() {
            $module.find(".btn_enquiry_flyingblock").attr("disabled", true);
            $module.find(".btn_enquiry_flyingblock").css("opacity", "0.7");
            var formData = $form.serializeObject();

            // fix (undefined | "" | string | string[]) to string[]
            var makeArray = function (value) { return !$.isArray(value) && value ? [value] : value || []; }

            // convert ["1-2", "2-3"] to [{from: 1, to: 3}, {from: 2, to: 3}]
            var parseStarRange = function (range) {
                var parts = range.split('-');
                return { from: +parts[0], to: +parts[1] };
            }

            var enquiryFilter = {
                themeId: parseInt(formData['filter.themeIds']) || 0,
                areaId: parseInt(formData['filter.areaIds']) || 0,
                stars: makeArray(formData['stars']).map(parseStarRange),
                boardingIds: makeArray(formData['filter.boardingIds']),
                amenityIds: makeArray(formData['filter.amenityIds'])
            };
            if (formData['filteravailability']) {
                if (!!formData.arrival && !!formData.departure && !!formData["rooms[0].adults"]) {
                    enquiryFilter = Object.assign(enquiryFilter,
                        {
                            availability: {
                                arrival: formData['arrival'],
                                departure: formData['departure'],
                                adults: formData['rooms[0].adults'],
                                childrenages: makeArray(formData['rooms[0].childrenages'])
                            }
                        });
                }
            }

            loading();
            $.ajax({
                cache: false,
                url: '/api/accos/count',
                type: 'POST',
                data: JSON.stringify(enquiryFilter),
                dataType: 'json',
                contentType: 'application/json',
                success: function(data) {
                    console.log('enquiry count', { request: enquiryFilter, response: data });
                    accosCountCallback(data.count);
                },
                error: function () {
                    console.log('enquiry count error');
                    accosCountCallback(0);
                }
            });
            function accosCountCallback(count) {
                setTimeout(() => {
                    loading();
                    $module.find(".enquiryCount").html("<b>" + count + "</b>");
                    $module.find('.enquiryCount b').show();
                    if (count === 1) {
                        $module.find(".enquiryCompanyCount span").hide();
                        $module.find(".enquiryCount b").html(count) && oneCompanyCount.show();
                        $module.find('.enquiryCount b').show();
                    } else {
                        $module.find(".enquiryCompanyCount span").show();
                        oneCompanyCount.hide();
                    }
                    if (count == 0) {
                        $module.find(".errorFilter").show();
                        //$module.find(".btn_enquiry_flyingblock").attr("disabled", true);
                        //$module.find(".btn_enquiry_flyingblock").css("opacity", "0.7");
                    } else {
                        $module.find(".errorFilter").hide();
                        $module.find(".btn_enquiry_flyingblock").attr("disabled", false);
                        $module.find(".btn_enquiry_flyingblock").css("opacity", "1");
                    }
                }, 300);
            }
        }

    //    function bindAvailability($form) {
    //        var labelFull = $form.find(".js-availability .-full");
    //        var labelFree = $form.find(".js-availability .-free");
    //        var btn = $form.find(".js-availability .btn");
    //        btn.on("click", function (e) {
    //            $form.valid();
    //            var formData = $form.serializeObject();
    //            if (!!formData.arrival && !!formData.departure && !!formData["rooms[0].adults"] && !!formData["rooms[0].children"]) {
    //                loading(true);
    //                $.ajax({
    //                    url: "/enquiry/availability",
    //                    type: "POST",
    //                    data: formData,
    //                    success: function (data) {
    //                        loading(false);
    //                        labelFree.toggle(true);
    //                        labelFull.toggle(false);
    //                    },
    //                    error: function (data) {
    //                        loading(false);
    //                        labelFree.toggle(false);
    //                        labelFull.toggle(true);
    //                    }
    //                });
    //            }
    //        })

    //    }
    });

    function bindValidation($form) {
        var portalId = $form.find('input[name="portalId"]')[0].value;
        $form.validate({
            rules: {
                'enquiryform-arrival': {
                    required: true
                },
                'enquiryform-departure': {
                    required: true
                },
                firstname: { required: true },
                lastname: { required: true },
                privacy: { required: true },
                adults: { required: true },
                areaids: { required: true },
                cars: { required: true },
                phone: portalId == "2301" ? { required: true } : { required: false },
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                arrival: $('[name="arrival"]').data("required"),
                departure: $('[name="departure"]').data("required"),
                firstname: $('[name="firstname"]').data("required"),
                lastname: $('[name="lastname"]').data("required"),
                privacy: $('[name="privacy"]').data("required"),
                'rooms[0].adults': $('[name="rooms[0].adults"]').data("required"),
                'filter.areaIds': $('[name="areaIds"]').data("required"),
                cars: $('[name="cars"]').data("required"),
                phone: $('[name="phone"]').data("required"),
                email: {
                    required: $('[name="email"]').data("required"),
                    email: $('[name="email"]').data("email")
                }
            }
        });
    }
});


// validator saveShowErrors extension
$.validator.prototype.saveShowErrors = function (errors) {
    var fixedErrors = {};
    for (var e in errors) {
        if (errors.hasOwnProperty(e)) {
            var fixedName = e.replace(/^enquiryData\./, '').toLowerCase();
            fixedErrors[fixedName] = errors[e];
        }
    }

    errors = fixedErrors;

    var deletedErrors = "";
    for (var e in errors) {
        if (errors.hasOwnProperty(e)) {
            var el = $("[name='" + e + "']")[0];
            if (!el) {
                if (e === "regionid") { }
                deletedErrors += e + " : " + errors[e] + "\n";
                delete errors[e];
            }
        }
    }
    // TODO better error messageing;
    if (deletedErrors !== "") {
        deletedErrors = "$.validator: could not display all errors:\n" + deletedErrors;
        console.error(deletedErrors);
        alert(deletedErrors);
    }
    console.log(errors);
    this.showErrors(errors);
};